import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Tag', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 2,
      border: `1px solid ${navy[700]}`,
      background: `${blue[500]}0a`,
      color: '#e2e8f0',

      '&:hover': {
        borderColor: `${blue[500]}60`,
      },

      [`${componentCls}-close-icon`]: {
        color: `#94a3b8 !important`,
        '&:hover': {
          color: `${blue[400]} !important`,
        },
      },
    },
  }
})
